import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HoomvipStorage} from '../hoomvip-storage/hoomvip-storage.service';
import {Observable, throwError} from 'rxjs';
import {DoorCommands} from '../../shared/models/door.model';
import {ApiConfigService} from './api.config.service';
import {HTTP_CACHE_TTL_MS, HttpCacheService} from '../services/http-cache.service';

@Injectable({providedIn: 'root'})
export class DoorsService {
  constructor(private http: HttpClient, private hoomvipStorage: HoomvipStorage, private apiConfigService: ApiConfigService, private cache: HttpCacheService) {
  }

  getDoorCommands(): Observable<DoorCommands> {
    const apartmentId = this.hoomvipStorage.getApartment();
    if (apartmentId === null) {
      return throwError(() => new Error('Apartment ID is required'));
    }
    const url = this.apiConfigService.getDoorsUrl(apartmentId);
    const key = `DoorsService:GET:${url}`;

    return this.cache.getOrSet<DoorCommands>(
      key,
      HTTP_CACHE_TTL_MS.IMPORTANT,
      () => this.http.get<DoorCommands>(url)
    );

  }

  openDoor(command: string) {
    const code = this.hoomvipStorage.getCode();
    return this.http.post(this.apiConfigService.postOpenDoorUrl(), {code, command});
  }
}
